import { render, staticRenderFns } from "./MenuMessageFilled.vue?vue&type=template&id=fbb51da6"
import script from "./MenuMessageFilled.vue?vue&type=script&setup=true&lang=js"
export * from "./MenuMessageFilled.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports